import { createContext, useContext } from 'react';

export type NavigateFn = (path: string | { pathname?: string; search?: string }) => void;

const BizyNavigationContext = createContext<NavigateFn | null>(null);

export function useBizyNavigationOverride() {
	return useContext(BizyNavigationContext);
}

export function fullPageNavigate(path: string | { pathname?: string; search?: string }): void {
	if (typeof path === 'string') {
		window.location.href = path;
	} else {
		window.location.href = (path.pathname ?? '') + (path.search ?? '');
	}
}

export { BizyNavigationContext };
